import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN Image variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */
export const imageVariants = cva(
  ['object-cover', 'transition-opacity duration-200'],
  {
    variants: {
      rounded: {
        true: 'rounded-xl',
        false: 'rounded-none',
        none: 'rounded-none',
        sm: 'rounded-sm',
        md: 'rounded-md',
        lg: 'rounded-lg',
        xl: 'rounded-xl',
        max: 'rounded-max',
      },
      objectFit: {
        cover: 'object-cover',
        contain: 'object-contain',
        fill: 'object-fill',
        none: 'object-none',
      },
    },
    defaultVariants: {
      rounded: false,
      objectFit: 'cover',
    },
  },
);

export type ImageVariantProps = VariantProps<typeof imageVariants>;
